/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ThreatVulnerabilityRequest {
    getFixupPrototypeFunction() { return ThreatVulnerabilityRequest.fixupPrototype; }

    static newInstance(model: Partial<ThreatVulnerabilityRequest>): ThreatVulnerabilityRequest {
        let obj = Object.assign(new ThreatVulnerabilityRequest(), model);
        ThreatVulnerabilityRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ThreatVulnerabilityRequest>): ThreatVulnerabilityRequest {
        if (!model) return null;
        return ThreatVulnerabilityRequest.newInstance(<ThreatVulnerabilityRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ThreatVulnerabilityRequest) {
        if (!obj) return;

        models.ThreatVulnerabilityRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ThreatVulnerabilityRequest): boolean {
        Object.setPrototypeOf(obj, ThreatVulnerabilityRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.list_context) {
            models.ListContext.fixupPrototype(this.list_context);
        }
        if (this.filters) {
            models.ThreatVulnerabilityFilters.fixupPrototype(this.filters);
        }
        if (this.sort) {
            for (let val of this.sort) {
                models.ThreatVulnerabilitiesFiltersRequestSortCriteria.fixupPrototype(val);
            }
        }
    }

    /**
     * Optional list context
     */
    list_context: models.ListContext;

    /**
     * Sort criteria
     */
    sort: Array<models.ThreatVulnerabilitiesFiltersRequestSortCriteria>;

    /**
     * Filters for the request
     */
    filters: models.ThreatVulnerabilityFilters;

}
